import Baloon from '../Baloon';

class Icecream extends Baloon {
  constructor(THREE) {
    super(THREE);
    this.id = 'icecream';
  }
}

export default Icecream;
